module.exports = __webpack_public_path__ + "resources/img/logo_partner_web_danvistore.451e1fcc32a836f67d5f7fe6baa89d0b.png";